import React, { useEffect, useState, useRef } from 'react';

// components
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from "reactstrap";
import MaterialTable from 'material-table';

// style
import { table_translate } from "constants/MaterialTable.js";

export default function PlanoContasDatasys({ isOpen, planoContas, handleReturn, disabledRows, planoContasSelected }) {

    const tableRef = useRef();

    const [plano_contas_checked, set_plano_contas_checked] = useState([]);
    const loadPlanoContasChecked = () => {
        let _selected = [];
        let _planoContas = [];
        
        planoContas.map(m => {
            if (planoContasSelected.filter(f => f.replace("|", "") == m.codigo).length > 0) 
            {
                _selected.push(m);
                m.tableData = { checked: true }
            }
            else{
                m.tableData = { checked: false }
            }
            _planoContas.push(m);
        });
        
        set_plano_contas_checked(_selected);
        set_list_table(_planoContas);
    }

    const [list_table, set_list_table] = useState([]);

    const CloseModal = () => {
        handleReturn(plano_contas_checked);
    }
    
    useEffect(() => {
        if (isOpen) {
            loadPlanoContasChecked();            
        }
        else if (tableRef.current) {
            tableRef.current.onAllSelected(false)
        }
    }, [isOpen]);

    return (
        <>
            <Modal isOpen={isOpen} toggle={CloseModal} size="lg">
                <ModalHeader toggle={CloseModal}>Planos de Conta - Datasys</ModalHeader>
                <ModalBody>
                    <MaterialTable style={{ minHeight: "auto" }}
                        title=""
                        tableRef={tableRef}
                        columns={[
                            { title: 'Código', field: 'codigo' },
                            { title: 'Descrição', field: 'descricao' },
                        ]}
                        data={list_table}
                        isLoading={false}
                        localization={table_translate}
                        options={{
                            exportButton: false,
                            selection: true,
                            showSelectAllCheckbox: false,
                            showTextRowsSelected: false,
                            selectionProps: rowData => ({
                                disabled: (rowData.sintetico || disabledRows.filter(f => f == rowData.codigo).length > 0),                                
                                color: 'success'
                            }),
                            headerStyle: {
                                fontFamily: 'Montserrat, Helvetica Neue, Arial, sans-serif',
                                fontWeight: '700',
                                color: '#888'
                            }
                        }}
                        onSelectionChange={(rows) => set_plano_contas_checked(rows)}
                    />
                </ModalBody>
                <ModalFooter className="text-right">
                    <Button color="default" onClick={CloseModal}> Confirmar</Button>
                </ModalFooter>
            </Modal>
        </>
    );
}

